<template>
  <div v-bind:id="id" class="form-group">
    <label v-if="label" class="form-label">{{ label }}
      <i v-if="required" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <div v-bind:class="{'is-invalid': invalid}">
      <i v-if="loading" class="fa fa-loading-black-16"></i>
      <template v-else="">
        <div v-if="noSelection" class="form-check">
          <input v-bind:id="id + ':no-select'"
                 v-bind:name="id"
                 type="radio"
                 v-bind:value="noSelectionValue"
                 v-bind:checked="noSelectionValue == value"
                 v-on:change="changed"
                 class="form-check-input"
                 v-bind:class="{'is-invalid': invalid}"/>
          <label v-bind:for="id + ':no-select'" class="form-check-label">{{ noSelectionLabel }}</label>
        </div>
        <div v-for="(option, i) in options" v-bind:key="'option' + i" class="form-check">
          <input v-bind:id="id + ':' + option.id"
                 v-bind:name="id"
                 type="radio"
                 v-bind:value="option.id"
                 v-bind:checked="option.id == value"
                 v-on:change="changed"
                 v-bind:disabled="option.disabled"
                 class="form-check-input"
                 v-bind:class="{'is-invalid': invalid}"/>
          <label v-bind:for="id + ':' + option.id" class="form-check-label">{{ option.name }}</label>
        </div>
      </template>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot name="help"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "select-one-radio",
  computed: {
    help: function () {
      return !!this.$slots.help;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  methods: {
    changed: function (event) {
      this.$emit("input", event.target.value);
    }
  },
  props: ["id", "value", "options", "noSelection", "noSelectionValue", "noSelectionLabel", "errors", "label", "language", "required", "loading"]
}
</script>
